import * as React from "react"
import * as ReactDom from "react-dom"
import Home from "../components/views/Home";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
	const homeContainer = document.getElementById('app')
	const HOMEINFO = window.drupalSettings.react.node || await requestPageData({ content: "home", nid: homeContainer.dataset.nid, langcode: checkLang() })
	const LOGOS = Object.values(window.drupalSettings.react.logos)
	ReactDom.render(<Home data={HOMEINFO} logos={LOGOS} />, homeContainer)
	setCanvas()
	setCurrentPage('')
}

function setCanvas() {
	const mapCanvas = document.querySelector("#storyboard-canvas");
	const containerCanvas = document.querySelector("#testCanvas");
	if (mapCanvas) {
		containerCanvas?.appendChild(mapCanvas)
	}
}